export const endpoint = 'https://gorgeous.works';
export const siteID = 7;
